





































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import PartnerModel from '@views/a-model/partner-model';
import DefaultModel from '@views/a-model/default-model';
import ImagePreviewModel from 'crop-image/src/ImagePreviewModel';
import EnumPartnerType from '../../dataSource/api/RunPay/DataModels/Enums/EnumPartnerType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';

@Component({
  name: 'partners',
  components: {},
})
export default class PartnersComponent extends Vue {
  innerItems: PartnerModel[] = [];

  pageSize = 10;
  currentPage = 0;
  totalItems = 0;

  partners: Array<PartnerModel> = [];
  innerPartners: Array<PartnerModel> = [];
  currentPageId = 0;

  innerImageCrope = '';
  maxSizeFileAvatar = 300000;

  /*
   *modal window
   */
  modalWindowShow = false;
  addingPartner: PartnerModel = new PartnerModel();
  // fileList:Array<any>=[];
  file: string = null;
  modalWindowCrop = false;
  Foto = new ImagePreviewModel();

  pages = Array<ListViewItem<DefaultModel>>();

  // @Watch("partners")
  // onChangePartners() {
  //   this.changePageId(this.currentPageId);
  // }
  // @Watch("file")
  // onChangeImage() {
  //   this.addingPartner.image = this.file;
  //  // this.modalWindowCrop = true;
  // }

  created() {
    document.title = this.$route.meta.title;
    this.getPages();
    this.getPartners({ Take: this.pageSize, Skip: this.currentPage });
    // this.changePageId(this.currentPageId);
  }

  isValid(): boolean {
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }

  getPages() {
    this.pages.push(new ListViewItem(new DefaultModel(1, '10'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(1, '15'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(1, '25'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(1, '100'), false, false));
  }

  getPartners({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.PartnersService.GetListEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.totalItems = response.Value.Count;
      this.partners = response.Value.Items.map((item) => ({
        id: item.Id,
        url: item.Url.toString(),
        type: item.Type,
        dateCreate: item.DateCreate,
        image: '',
      }));
    });
    this.$api.PartnersService.GetList({
      Skip: Skip,
      Take: Take,
      Type: this.getPartnerType(this.currentPageId),
    });
  }

  onFileChanged(date: Date) {
    console.log(date);
  }

  getImage(id: number): string {
    return '/files/partners/' + id + '.jpg';
  }

  onDownload() {
    (this.$refs.fileInput as any).click();
  }

  changePageId(pageId: number) {
    this.currentPageId = pageId;
    this.getPartners({ Take: this.pageSize, Skip: this.currentPage });
  }

  async onDeletePartner(id: number) {
    var res = await this.$dialog.confirm(this.$locale.getTranslate('Dialog_reallyDelete')).then((res: boolean) => {
      if (res) {
        this.$api.PartnersService.DeleteEvent.once((response) => {
          if (!response.IsSuccess) {
            return;
          }
          this.getPartners({ Take: this.pageSize, Skip: this.currentPage });
        });
        this.$api.PartnersService.Delete(id);
      }
      if (res == false) {
      }
    });
  }

  addPartner() {
    this.addingPartner = new PartnerModel();
    this.modalWindowShow = true;
    this.file = null;
  }

  onClickAddFile() {
    (this.$refs.fileInput as any).click();
  }

  imageBase64Ok(res: string) {
    this.innerImageCrope = res;
    // this.innerСropImagePreview=res
    this.modalWindowCrop = true;
  }

  onChangedImage() {
    var file = (this.$refs.fileInput as any).files[0];
    if (file.size > this.maxSizeFileAvatar) {
      alert(this.$locale.getTranslate('Dialog_photoSizeMustBeSmaller') + this.maxSizeFileAvatar / 1024 + this.$locale.getTranslate('Dialog_kbYourFileSize') + (file.size / 1024).toFixed(2) + ' кб');
      return;
    }
    this.getBase64(file).then(
      (res: string) => {
        this.imageBase64Ok(res);
      },
      (rej: string) => alert(rej)
    );
    (this.$refs.fileInput as any).value = null;
  }

  getBase64(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function() {
        resolve(reader.result.toString());
      };
      reader.onerror = function(error) {
        console.error('Error: ', error);
        reject(error);
      };
    });
  }

  // Обрезка картинки состоялась
  onCropedImage(res: any) {
    this.Foto = new ImagePreviewModel();
    this.Foto.ImageUrl = this.innerImageCrope;
    this.Foto.Width = res.width;
    this.Foto.Height = res.height;
    this.Foto.Left = res.left;
    this.Foto.Top = res.top;
    // this.ismodify=true
    // this.profileEditRequest.Foto={Image:this.general.Foto.ImageUrl,Width:this.general.Foto.Width,Height:this.general.Foto.Height,Top:this.general.Foto.Top, Left:this.general.Foto.Left}
    // this.$emit("changeFoto", this.general.Foto)
    this.modalWindowCrop = false;
  }

  closeModalWindow() {
    this.innerImageCrope = '';
    this.modalWindowShow = false;
  }

  createdPartner() {
    if (!this.isValid()) {
      return;
    }
    // this.partners.push({id:5, image:this.newPartner.image, link:this.newPartner.link,pageId:this.currentPageId})
    this.addingPartner.type = this.currentPageId;
    this.addingPartner.image = this.innerImageCrope.substring(this.innerImageCrope.indexOf(',') + 1) || null;
    this.$api.PartnersService.SaveEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.getPartners({ Take: this.pageSize, Skip: this.currentPage });
    });
    this.$api.PartnersService.Save({
      Url: this.addingPartner.url,
      Type: this.addingPartner.type,
      Image: this.addingPartner.image,
    });
    this.closeModalWindow();
  }

  onDeleteImage() {
    this.innerImageCrope = '';
  }

  async onDeleteParntner(newsId: string) {
    var res = await this.$dialog.confirm(this.$locale.getTranslate('Dialog_reallyDelete')).then((res: boolean) => {
      if (res) {
        this.$api.PartnersService.DeleteEvent.once((response) => {
          if (!response.IsSuccess) {
            return;
          }
          this.getPartners({ Take: this.pageSize, Skip: this.currentPage });
        });
        this.$api.PartnersService.Delete(parseInt(newsId));
      }
      if (res == false) {
      }
    });
  }

  onCreateParnter() {
    this.addingPartner.type = this.getPartnerType(this.currentPageId);
    this.addingPartner.image = this.innerImageCrope.substring(this.file.indexOf(',') + 1);

    this.$api.PartnersService.Save({
      Url: this.addingPartner.url,
      Type: this.addingPartner.type,
      Image: this.addingPartner.image,
    });
    this.modalWindowShow = false;
    this.getPartners({ Take: this.pageSize, Skip: this.currentPage });
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.getPartners({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage,
    });
  }

  getPartnerType(typeId: number): EnumPartnerType {
    switch (typeId) {
      case 0:
        return EnumPartnerType.MainPage;
        break;
      case 1:
        return EnumPartnerType.SecondPage;
        break;

      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-partners.vue